export default "__VITE_ASSET__1QkrnID$__"